import styled from 'styled-components'
import React from 'react'

import { H2, H4 } from './common/Typography'

export const RgpdText = () => (
  <Wrapper>
    <Header tradId="rgpdConfirm" bold />
    <Content>
      <Block>
        <Block>
          La navigation sur l&#39;application LesAlpps est soumise aux présentes conditions d&#39;utilisation.
        </Block>
        <Block>
          En accédant aux informations mises à disposition par l&#39;armée de Terre sur son application, vous
          reconnaissez avoir pris connaissance des présentes conditions d&#39;utilisation et les acceptez.
        </Block>
      </Block>
      <H4 bold>Editeur</H4>
      <Block>
        <div>
          Fabrique Numérique, incubateur de services numériques du ministère des Armées
        </div>
        <div>
          60 Boulevard du Général Martial Valin
        </div>
        <div>
          75015 Paris
        </div>
      </Block>
      <H4 bold>Hébergeur</H4>
      <Block>
        <div>
          AntemetA
        </div>
        <div>
          5 rue Jacqueline Auriol
        </div>
        <div>
          78280 Guyancourt
        </div>
      </Block>
      <H4 bold>Loi applicable</H4>
      <Block>
        <div>Le contenu de cette application est régi par la loi française.</div>
      </Block>
      <H4 bold>Données personnelles</H4>
      <Block>
        <Block>
          Un traitement de vos données à caractère personnel est mis en œuvre par le Major général de l’armée de
          Terre, en sa qualité de responsable de traitement, appartenant au ministère des Armées.
        </Block>
        <Block>
          La collecte de vos données à caractère personnel est destinée à des fins de suivi et de couverture des
          courses à travers les FACM, ainsi que d’évaluation des stagiaires selon des critères de compétences données.
        </Block>
        <Block>
          Le directeur des affaires juridiques assure la fonction de délégué à la protection des données. Votre
          consentement est nécessaire à la mise en œuvre du traitement. Vos données seront transmises, pour les
          besoins du traitement aux unités organisatrices dont vous dépendez.
          Vos données seront conservées pendant la durée de votre affectation dans votre unité.
        </Block>
        <Block>
          Conformément au règlement général sur la protection des données (RGPD) [règlement (UE) 2016/679 du Parlement
          européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l’égard du
          traitement des données à caractère personnel et à la libre circulation de ces données, et abrogeant la
          directive 95/46/CE], la collecte, l&#39;enregistrement et la conservation automatisés de données à caractère
          personnel s&#39;effectuent sur cette application dans le cadre de la déclaration d&#39;un traitement
          d&#39;informations personnelles au registre des traitements du responsable de traitement. Les droits
          d&#39;accès, de rectification et d’effacement prévus par le RGPD s&#39;exercent par courriel à l&#39;adresse
          : emat-rgpd.contact.fct@intradef.gouv.fr.
        </Block>
        <Block>
          L’application LesAlpps de l’armée de Terre est éditée par la « Fabrique Numérique, incubateur de services
          numériques du ministère des Armées situé au  60 Boulevard du Général Martial Valin 75015 Paris ».
        </Block>
        <Block>
          Si vous estimez que vos droits en matière de protection des données ne sont pas respectés, vous pouvez
          adresser une réclamation en ligne à la CNIL ou par courrier postal.
        </Block>
        <Block>
          Si vous ne souhaitez pas que vos données soient traitées, vous ne pourrez pas utiliser l’application.
        </Block>
      </Block>
    </Content>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 500px) {
    margin: 40px;
  }
`

const Block = styled.div`
  margin: 5px 0 10px 0;
`

const Content = styled.div`
  height:400px;
  overflow: auto;
`

const Header = styled(H2)`
  margin-bottom: 10px;
`
